export const Z_LAYERS = {
	background: 0,
	content: 10,
	floatingSpaceBase: 500,
	floatingSpaceStep: 5,
	popover: 850,
	contextMenu: 900,
	modal: 1000,
} as const;
